/**
 * Courier booking types, by every name they have ever had.
 *
 * Renamed from 'Delivery' / 'Pickup' to 'Delivery Service Only' /
 * 'Pickup Service Only' (2026-07-27), matching 'Laundry Service Only' and
 * reading properly on an invoice.
 *
 * The portal compares these as STRINGS in several places — the bookings list
 * grouping and badges, the daily report, scheduling, and the warehouse's pickup
 * handling. A rename is a database change and a code change, and they cannot
 * land in the same instant, so every comparison accepts BOTH spellings and
 * neither order breaks. Once no row uses the old names, drop the old entries.
 */

export const DELIVERY_TYPES = ['Delivery Service Only', 'Delivery'];
export const PICKUP_TYPES = ['Pickup Service Only', 'Pickup'];

/**
 * Delivered by the BUILDING'S porter, not by us — so it is never a driver's
 * job and is deliberately NOT a courier type here (2026-07-27).
 */
export const PORTER_TYPES = ['Porter Delivery'];

export const isDeliveryType = (t) => DELIVERY_TYPES.includes(t);
export const isPickupType = (t) => PICKUP_TYPES.includes(t);
export const isPorterType = (t) => PORTER_TYPES.includes(t);

/** Errands a DRIVER runs. Porter deliveries are not among them. */
export const isCourierType = (t) => isDeliveryType(t) || isPickupType(t);

/**
 * What to SHOW for a booking type.
 *
 * 'Delivery Service Only' and 'Pickup Service Only' read correctly on an
 * invoice and are far too long on a card, a badge or a route list, where the
 * word repeats down the column (2026-07-27). The stored name is unchanged
 * — this is display only.
 */
export const displayBookingType = (t) => {
    if (isDeliveryType(t)) return 'Delivery';
    if (isPickupType(t)) return 'Pickup';
    return t;
};
